import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {useMutation} from 'react-apollo'
import {notification} from 'antd'
import Button from 'components/shared/Button'

const addTeaserMutation = gql`
  mutation AddTeaserToVideoProduct($id: ID!) {
    AddTeaserToVideoProduct(id: $id) {
      product {
        id
        ...on VideoProduct {
          teaser
        }
      }
    }
  }
`

const removeTeaserMutation = gql`
  mutation RemoveTeaserFromVideoProduct($id: ID!) {
    RemoveTeaserFromVideoProduct(id: $id) {
      product {
        id
        ...on VideoProduct {
          teaser
        }
      }
    }
  }
`

const ToggleTeaser = ({product}) => {
  const [addTeaser, {loading: adding}] = useMutation(addTeaserMutation, {
    onCompleted: () => {
      notification.success({
        message: 'Teaser bestilt',
        description: 'Teaser er bestilt for dette produktet.',
      })
    },
    onError: () => {
      notification.error({
        message: 'Bestilling feilet',
        description: 'Kunne ikke legge til teaser grunnet en feil. Forsøk på nytt senere.',
      })
    },
  })
  const [removeTeaser, {loading: removing}] = useMutation(removeTeaserMutation, {
    onCompleted: () => {
      notification.success({
        message: 'Teaser fjernet',
        description: 'Teaser er fjernet for dette produktet.',
      })
    },
    onError: () => {
      notification.error({
        message: 'Fjerning feilet',
        description: 'Kunne ikke fjerne teaser grunnet en feil. Forsøk på nytt senere.',
      })
    },
  })

  const loading = adding || removing

  return (
    <div className="toggle-teaser">
      <p>
        Video leveres i utgangspunktet som én lenke. Ønsker du i tillegg en kortere teaser som kan brukes i annonsering, kan du bestille dette her.
      </p>
      {!product.teaser && (
        <Button
          loading={loading}
          disabled={loading}
          onClick={() =>
            addTeaser({
              variables: {
                id: product.id,
              },
            })
          }
        >
          Legg til teaser (+{product.teaserUnitPrice}kr)
        </Button>
      )}
      {!!product.teaser && (
        <Button
          loading={loading}
          disabled={loading}
          onClick={() =>
            removeTeaser({
              variables: {
                id: product.id,
              },
            })
          }
        >
          Fjern teaser
        </Button>
      )}
    </div>
  )
}

ToggleTeaser.propTypes = {
  product: PropTypes.object.isRequired,
}

export default ToggleTeaser
